/**
 * Navigation state of a switch between the files of a group (file tabs of the contractualisation):
 * the subscription process reloads behind the page instead of showing its skeleton.
 */
export const FILE_GROUP_SWITCH_STATE = { fileGroupSwitch: true } as const;

export const isFileGroupSwitch = (state: unknown): boolean =>
  typeof state === 'object' && state !== null && (state as { fileGroupSwitch?: unknown }).fileGroupSwitch === true;
